// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../modules/ubercabinet/views/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../modules/ubercabinet/views/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hasEdgeBorder {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;
    border: 0;
    box-sizing: border-box;
    width: 100%;
    height: auto;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        filter: brightness(0.75) contrast(0.75);
        border-radius: 5px;
    }

    &.hasLeftEdgeBorder::after {
        border-left: 5px solid white;
    }
    &.hasRightEdgeBorder::after {
        border-right: 5px solid white;
    }
    &.hasTopEdgeBorder::after {
        border-top: 5px solid white;
    }
    &.hasBottomEdgeBorder::after {
        border-bottom: 5px solid white;
    }
}`, "",{"version":3,"sources":["webpack://./../../../themes/uc_base_theme/assets/css/edge.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,SAAS;IACT,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,YAAY;;IAEZ;QACI,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,uCAAuC;QACvC,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;IAChC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".hasEdgeBorder {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    box-sizing: border-box;\n    width: 100%;\n    height: auto;\n\n    &::after {\n        content: \"\";\n        position: absolute;\n        inset: 0;\n        filter: brightness(0.75) contrast(0.75);\n        border-radius: 5px;\n    }\n\n    &.hasLeftEdgeBorder::after {\n        border-left: 5px solid white;\n    }\n    &.hasRightEdgeBorder::after {\n        border-right: 5px solid white;\n    }\n    &.hasTopEdgeBorder::after {\n        border-top: 5px solid white;\n    }\n    &.hasBottomEdgeBorder::after {\n        border-bottom: 5px solid white;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
